import React from 'react'
import RuntimeConfigApi from 'src/api/RuntimeConfigApi'
import { RouteLoader } from 'src/components/Loader'

const runtimeConfigClient = new RuntimeConfigApi()
const RuntimeConfigContext = React.createContext({})

/**
 * @param ComponentToWrap
 * @param configKey
 * @returns {function(*): *}
 */
export default function withRuntimeConfigLoader(ComponentToWrap, configKey) {
    const LazyComponent = React.lazy(async () => {
        const config = await runtimeConfigClient.fetchConfig({
            key: configKey,
        })

        return {
            default: function ComponentWithRuntimeConfig(props) {
                return (
                    <RuntimeConfigContext.Provider value={config.data}>
                        <ComponentToWrap {...props} />
                    </RuntimeConfigContext.Provider>
                )
            },
        }
    })

    return function WrappedComponent(props) {
        return (
            <React.Suspense fallback={<RouteLoader />}>
                <LazyComponent {...props} />
            </React.Suspense>
        )
    }
}

export { RuntimeConfigContext }
